// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--7-oneOf-3-1!../../../node_modules/sass-loader/dist/cjs.js??ref--7-oneOf-3-2!./variables.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("c5c0fb84", content, false, {"sourceMap":false,"shadowMode":false});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--7-oneOf-3-1!../../../node_modules/sass-loader/dist/cjs.js??ref--7-oneOf-3-2!./variables.scss", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js??ref--7-oneOf-3-1!../../../node_modules/sass-loader/dist/cjs.js??ref--7-oneOf-3-2!./variables.scss");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}